import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 'calc(100vw - 6rem)',

    [theme.breakpoints.down('md')]: {
      maxWidth: 'calc(100vw - 1rem)'
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',

    '& > small': {
      margin: '0.125rem 0 0 0.5rem',
      fontSize: theme.size.sm,
      opacity: '0.35'
    }
  },

  bottomRow: {
    '& .children': {
      [theme.breakpoints.down('md')]: {
        display: 'grid !important',
        gridTemplateRows: '25px'
      }
    }
  }
}))

export default useStyles
